import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { database } from "../firebase";
import { ref, get, child } from "firebase/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTiktok, faInstagram, faDiscord, faBluesky, faReact} from "@fortawesome/free-brands-svg-icons";


const PRM = ({ title, description }) => {
  const [posts, setPosts] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const menuItems = [
    { emoji: "📍", text: "Find Us", link: "https://sites.google.com/view/priderevolutionmovement/where-to-find-us" },
    { emoji: "🤝", text: "Get Involved", link: "https://sites.google.com/view/priderevolutionmovement/get-involved" },
    { emoji: "📚", text: "Resources", link: "https://sites.google.com/view/priderevolutionmovement/resources" }
  ];

  useEffect(() => {
  const fetchPosts = async () => {
    const dbRef = ref(database);
    try {
      const snapshot = await get(child(dbRef, "partnerships/prmposts"));
      if (snapshot.exists()) {
        const data = snapshot.val();
        
        // Exclude 'whoweareimg' from the posts list
        const filteredPosts = Object.entries(data)
          .filter(([key]) => key !== "whoweareimg") // Remove whoweareimg
          .map(([_, value]) => value); // Extract the values
        
        setPosts(filteredPosts);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  fetchPosts();
}, []);

  useEffect(() => {
    const fetchImages = async () => {
      const dbRef = ref(database);
      try {
        const snapshot = await get(child(dbRef, "partnerships/prmposts/whoweareimg"));
        if (snapshot.exists()) {
          setImageUrls(Object.values(snapshot.val()));
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  if (posts.length === 0)
    return (
      <div className="prm-loading-container">
        <div className="prm-loading-spinner"></div>
      </div>
    );

  return (
    <>
      <Helmet>
        <title>{title || "Rainbow Revolution Movement - EnbyBase Official Website"}</title>
        <meta
          name="description"
          content={description || "Rainbow Revolution Movement, Partner of EnbyBase Alliance"}
        />
        <meta property="og:title" content={title || "Rainbow Revolution Movement - EnbyBase Official Website"} />
        <meta property="og:description" content={description || "Rainbow Revolution Movement, Partner of EnbyBase Alliance"} />
      </Helmet>
<div className="prm-bg">
      <div className="prm-section-title">
      <span className="prm-section-subtitle">Announcements</span>
      <h2 className="prm-section-heading">From Rainbow Revolution Movement</h2>
    </div>

      <div className="prm-blog-container">
        {posts.map((post, index) => (
          <div key={index} className="prm-blog-card col-lg-4 col-md-6">
            <div className="prm-single-blog-item">
              <div className="prm-blog-image">
                <a href={post.link} target="_blank" rel="noopener noreferrer">
                  <img alt="image" src={post.image} />
                </a>
              </div>
              <div className="prm-blog-content">
                <ul className="prm-post-meta">
                  <li>
                    <i className="bookmark" />
                    {post.bookmark}
                  </li>
                  <li>
                    <span>Date:</span> {post.date}
                  </li>
                </ul>
                <h3>
                  <a href={post.link} target="_blank" rel="noopener noreferrer">
                    {post.title}
                  </a>
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="prm-container">
          <div className="prm-row">
            <div className="prm-col-lg-3 prm-col-md-6">
              <div className="prm-single-teacher-content">
                <span className="prm-title">A Little Recommend</span>
                <h3>
                  <a href="https://linktr.ee/youth.rainbowrevolution" className="prm-link">
                    Our Organisation
                  </a>
                </h3>
                <p>Pride Revolution, a global, teen-led movement dedicated to advocating for queer and trans youth in any way we can.</p>
                <div className="prm-teacher-btn">
                  <a href="https://linktr.ee/youth.rainbowrevolution" className="prm-default-btn" target="_blank" rel="noopener noreferrer">
                    Linktree
                  </a>
                  <a href="https://sites.google.com/view/priderevolutionmovement/home" className="prm-default-btn" target="_blank" rel="noopener noreferrer">
                    Website
                  </a>
                </div>
              </div>
            </div>

            {/* Image Cards from Firebase */}
            {imageUrls.length > 0 ? (
              imageUrls.map((src, index) => (
                <div key={index} className="prm-col-lg-3 prm-col-md-6">
                  <div className="prm-single-teacher-item">
                    <div className="prm-image">
                      <img src={src} alt={`Media ${index}`} />
                      <div className="prm-content">
                        <ul className="prm-social">
                          <li>
                            <a href={src} className="prm-social-btn" target="_blank" rel="noopener noreferrer">
                              <i className="bx bxs-file-pdf"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>Loading images...</p>
            )}

        </div>
        </div>

        <div className="prm-footer-widget">
      <div className="prm-logo">
        <h2>
          <a href="https://sites.google.com/view/priderevolutionmovement/home">
            <img
              width={250}
              alt="image"
              src="https://res.cloudinary.com/dwpx3t29p/image/upload/v1739005227/partnerships/prm/communityIcon_vaf9a92zrnhe1_m4ayj3.png"
            />
          </a>
        </h2>
      </div>
      <p className="prm-description">Rainbow Revolution Movement <br></br> Formally known as Pride Revolution Movement</p>
      <p className="prm-address">
      <a href="mailto:youth.priderevolution@gmail.com">youth.priderevolution@gmail.com</a>
      </p>
      <ul className="prm-social">
      <div className="prms-footer-icons">
        <a href="https://tiktok.com/@pride_movement4teens" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTiktok} size="sm" /></a>
        <a href="https://instagram.com/pride_revolution" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} size="sm" /></a>
        <a href="https://bsky.app/profile/prmofficial.bsky.social" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faBluesky} size="sm" /></a>
        <a href="https://discord.gg/qDDDecAz2t" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faDiscord} size="sm" /></a>
        <a href="/PRMAdmin" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faReact} size="sm" /></a>
      </div>
      </ul>
    </div>
      </div>

      <div className="prms-sidebar-container">
      {menuItems.map((item, index) => (
        <div
          key={index}
          className={`prms-sidebar-bar ${hoveredIndex === index ? "prms-expanded" : ""}`}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <span className="prms-sidebar-emoji">{item.emoji}</span>
          <a href={item.link} className="prms-sidebar-link">
            {item.text}
          </a>
        </div>
      ))}
    </div>

    </>
  );
};

export default PRM;